<template>
  <Header />
  <div class="title-container">
    <h1>Aircraft</h1>
    <div class="filter-container">
      <input v-model="nameSearchQuery" placeholder="Search by Aircraft Name" />
    </div>
    <button class="back-button" @click="goBack">Back</button>
  </div>

  <div class="container-fluid-trainee">
    <vue-good-table :columns="columns" :rows="processedRows" :pagination-options="{
      enabled: true,
      perPage: perPage
    }" :search-options="{
      enabled: false
    }" :sort-options="{
      enabled: true,
    }">
      <template #table-row="props">
        <span v-if="props.column.field === 'actions'" class="center-icons">
          <font-awesome-icon icon="edit" class="edit-icon" title="Edit aircraft"
            @click="openEditAircraft(props.row.aircraft_id)" />
          <font-awesome-icon icon="trash-alt" class="delete-icon" title="Delete aircraft"
            @click="deleteAircraft(props.row.aircraft_id)" />
        </span>
        <span v-else :title="String(props.formattedRow[props.column.field] ?? '')">
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
  <div>
    <button class="btn btn-primary rounded" id=addlogbookButton @click="openAddAircraft">Add Aircraft</button>
  </div>

  <aircraft-modal v-if="showAircraftModal" :mode="modalMode" :aircraft="selectedAircraft" :aircrafts="aircraft"
    @close="closeAircraftModal" @saved="fetchAircraft" />
</template>

<script>
import Header from '../Header.vue';
import axios from 'axios';
import { VueGoodTable } from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import AircraftModal from './AddEditAircraftModal.vue';

export default {
  name: 'ViewAircraft',
  components: {
    VueGoodTable,
    Header,
    AircraftModal,
  },

  data() {
    return {
      aircraft: [],
      nameSearchQuery: '',
      perPage: 10,
      showAircraftModal: false,
      modalMode: "add",   // or 'edit'
      selectedAircraft: null,
      columns: [
        { label: 'ID', field: 'aircraft_id', sortable: true, thClass: 'vgt-id-column', tdClass: 'vgt-id-column' },
        { label: 'Name', field: 'name', sortable: true, thClass: 'vgt-name-column', tdClass: 'vgt-name-column' },
        { label: 'Actions', field: 'actions', sortable: false, thClass: 'vgt-actions-column', tdClass: 'vgt-actions-column' },
      ],
    };
  },
  computed: {
    processedRows() {
      return this.aircraft
        .filter((c) =>
          (c.name || '').toLowerCase().includes(this.nameSearchQuery.toLowerCase())
        );
    }
  },
  methods: {
    async fetchAircraft() {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        let result = await axios.get('/api/aircraft', { headers });
        this.aircraft = result.data;

      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    },
    openAddAircraft() {
      this.modalMode = "add";
      this.selectedAircraft = null;
      this.showAircraftModal = true;
    },
    openEditAircraft(aircraft_id) {
      this.modalMode = "edit";
      this.selectedAircraft = this.aircraft.find(a => a.aircraft_id === aircraft_id);
      this.showAircraftModal = true;
    },
    closeAircraftModal() {
      this.showAircraftModal = false;
      this.fetchAircraft();
    },
    async deleteAircraft(id) {
      if (!confirm('Are you sure you want to delete this Aircraft?')) return;
      if (!confirm('This action will PERMANENTLY delete the aircraft from the database. Do you wish to continue?')) return;

      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      try {
        const response = await axios.delete(`/api/aircraft/${id}`, { headers });

        if (response.status === 200) {
          // await removeItemFromCacheByUrl(`/api/aircraft/${id}`);
          this.aircraft = this.aircraft.filter(a => String(a.aircraft_id) !== String(id));
          window.alert('Aircraft deleted successfully');
        }
      } catch (error) {
        if (error.isOffline === true && error.queued) {
          this.aircraft = this.aircraft.filter(a => String(a.aircraft_id) !== String(id));
          alert('You are offline. The delete has been queued and will sync later.');
          return;
        }

        const msg = error.response?.data?.message || '';
        if (msg.includes('SQLSTATE[23000]') && msg.includes('1451')) {
          alert(`This aircraft cannot be deleted because it is linked to a ${this.$labels.product}.`);
        } else {
          alert('An error occurred while deleting.');
        }
      }
    },
    goBack() {
      this.$router.push({ name: 'products' });
    },
  },
  async mounted() {
    await this.fetchAircraft();
  },
};
</script>


<style scoped>
.container-fluid-trainee {
  padding-top: 10px;
  width: 97%;
  /* Ensure the container takes up full width */
  margin-left: 1.5%;
  margin-right: 1.5%;
  display: flex;
  /* Use flexbox for centering */
  justify-content: center;
  /* Center the content horizontally */
}

button.btn#addlogbookButton {
  padding: 10px 10px;
  font-size: 16px;
  width: 180px;
  height: 42px;
  margin-top: 0px;
  margin-bottom: 15px;
  margin-right: 20px;
  border: 1px solid rgb(0, 96, 134);
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
  float: right;
}

button.btn#addlogbookButton:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

input {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  width: 200px;
  margin-right: 10px;
}

h1 {
  padding-top: 0px;
  padding-left: 3%;
}

label {
  margin-top: 8px;
}

.edit-icon {
  font-size: 16px;
  /* Adjust the size as needed */
  color: #615f5f;
  /* Change the color to your preference */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
}

.edit-icon:hover {
  color: #2b2a2a;
  /* Change the color to your preference */
  cursor: pointer;
  transform: scale(1.1);
  /* Example transform for scaling on hover */

}

.delete-icon {
  font-size: 16px;
  color: #FF0000;
  /* Red color */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
  padding-left: 15px;
}

.delete-icon:hover {
  color: #a82222;
  /* Lighter red color on hover */
  cursor: pointer;
  transform: scale(1.1);
  /* Scale the icon on hover */
  /* You can also add a box-shadow or any other styles you prefer */
}

.back-button {
  width: 100px;
  margin-right: 20px;
  border-radius: 5px;
  background-color: #c1e0bf;
  font-size: 14px;
  border: 2px solid black;
  padding: 3px;
}

.back-button:hover {
  background-color: #abc7a9;
  cursor: pointer;
}

.title-container {
  margin-top: 20px;
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-container {
  display: flex;
  margin-left: auto;
}
</style>